import { Box, Card, Skeleton, Stack } from "@mui/material";

export default function FinalReportVisitCardSkeleton() {
    return (
        <Card sx={{ padding: 2 }} variant="outlined">
            <Stack direction="row" columnGap={2}>
                <Stack flex={2} rowGap={2}>
                    <Stack>
                        <Skeleton variant="text" width={100} height={16} />
                        <Skeleton variant="text" width={200} height={32} />
                        <Skeleton variant="text" width={140} height={16} />
                    </Stack>
                    <Stack>
                        <Skeleton variant="text" width={160} height={16} />
                        <Skeleton variant="text" width={120} height={16} />
                    </Stack>
                </Stack>
                <Box flex={1}>
                    <Stack rowGap={2}>
                        {[1, 2, 3].map(i => (
                            <Stack key={i} direction="row">
                                <Stack direction="row" alignItems="center" columnGap={1} flex={1}>
                                    <Skeleton variant="circular" width={24} height={24} />
                                    <Stack>
                                        <Skeleton variant="text" width={60} height={16} />
                                        <Skeleton variant="text" width={40} height={24} />
                                    </Stack>
                                </Stack>
                                <Stack direction="row" alignItems="center" columnGap={1} flex={1}>
                                    <Skeleton variant="circular" width={24} height={24} />
                                    <Stack>
                                        <Skeleton variant="text" width={60} height={16} />
                                        <Skeleton variant="text" width={40} height={24} />
                                    </Stack>
                                </Stack>
                            </Stack>
                        ))}
                    </Stack>
                </Box>
            </Stack>
        </Card>
    );
}
